import { track } from "jiffy-analytics";
import { on } from "common/utils/ui/event";
import initDesignUploadModal, {
  showDesignUploadModal
} from "components/jiffy/design-upload-cta/design-upload-cta";

const START_DESIGNING_SELECTOR = ".js-start-designing";

// Trigger location constants
const TRIGGER_LOCATIONS = {
  BUSINESS_TILE: "Business Tile",
  TOP_TILE: "Top Tile (G640)",
  PRODUCT_CARD: "Product Card"
};

const extractProductData = element => {
  const { catalogNumber, designLibraryUrl, canvaUrl, color, productId, isFeatured } =
    element.dataset;
  return {
    catalogNumber,
    designLibraryUrl,
    canvaUrl,
    color,
    productId,
    isFeatured: isFeatured === "true"
  };
};

const handleHeroCard = () => {
  const triggerLocation = TRIGGER_LOCATIONS.BUSINESS_TILE;
  track("upload_step_viewed", { trigger_location: triggerLocation });
  showDesignUploadModal(false, { trigger_location: triggerLocation });
};

const handleCustomsNav = customsNav => {
  const productData = extractProductData(customsNav);
  if (productData.catalogNumber) {
    showDesignUploadModal(true, productData);
  }
};

const handleProductCard = productCard => {
  const productData = extractProductData(productCard);
  if (productData.catalogNumber) {
    const triggerLocation = productData.isFeatured
      ? TRIGGER_LOCATIONS.TOP_TILE
      : TRIGGER_LOCATIONS.PRODUCT_CARD;
    track("upload_step_viewed", {
      product_id: productData.productId,
      trigger_location: triggerLocation
    });
    showDesignUploadModal(true, productData);
  }
};

const initGlobalStartDesigning = () => {
  initDesignUploadModal();

  on("click", START_DESIGNING_SELECTOR, e => {
    e.preventDefault();
    e.stopPropagation();

    const heroCard = e.target.closest(".js-hero-card");
    const productCard = e.target.closest("[data-catalog-number]");
    const customsNav = e.target.closest("[data-testid='nav-design-lab']");

    if (heroCard) {
      handleHeroCard();
    } else if (customsNav) {
      handleCustomsNav(customsNav);
    } else if (productCard) {
      handleProductCard(productCard);
    } else {
      showDesignUploadModal(false);
    }
  });
};

export default initGlobalStartDesigning;
